import { invert } from "lodash/object"

export const LOCAL_STORE_TOKEN = "ctoken"
export const LOCAL_STORE_PREF = "pref"
export const EDIT_ROLES = ["ADMIN", "EDITOR"]

export const APPEND_SEARCH_FILTER = "curtis/append-search-filter"
export const REMOVE_SEARCH_FILTER = "curtis/remove-search-filter"
export const ADD_SEARCH_FILTER_CONTROL = "curtis/add-search-filter-control"
export const REMOVE_SEARCH_FILTER_CONTROL =
  "curtis/remove-search-filter-control"
export const SET_FROM_TOKEN = "curtis/set-from-token"
export const SET_ACTIVE_COLLECTIONS = "curtis/set-active-collection"
export const SET_PER_PAGE = "curtis/set-per-page"
export const SET_ARTICLE_STYLE = "curtis/set-article-style"
export const LOAD_PREFERENCES = "curtis/load-peferences"
export const SEARCH_SORT = "curtis/search-sort"
export const SEARCH_SCROLL_POSITION = "curtis/search-scroll-position"
export const SEARCH_LOAD_MORE = "curtis/search-load-more"
export const SEARCH_LOADING = "curtis/search-loading"
export const SHOW_SEARCH_FILTERS = "curtis/show-search-filters"
export const SET_STATE_FROM_PARAMS = "curtis/set-from-params"
export const SET_RESULT_IDS = "curtis/set-result-ids"
export const SET_LOCALE = "curtis/set-locale"
export const SET_BOUNDING_BOX = "curtis/set-bounding-box"
export const DEFAULT_ARTICLE_STYLE = "fluid"
export const DEFAULT_PAGE_SIZE = 30
export const DEFAULT_PER_PAGE = 30
export const DEFAULT_LOCALE = "en"

export const HELD_IN_NAMES = {
  community_archives: "Community Archives",
  coolstore: "Coolstore",
  imca_digital_archive: "IMCA Digital Archive",
  other: "Other",
  outsize: "Outsize",
  pncc_archives: "PNCC Archives",
  research_file: "Research File"
}

export const FORMAT_NAMES = {
  b_and_w_negative: "B&W negative",
  b_and_w_print: "B&W print",
  born_digital: "Born Digital",
  colour_negative: "Colour negative",
  colour_print: "Colour print",
  dvd: "DVD (video disc)",
  glass_negative: "Glass negative",
  other: "Other",
  paper: "Paper",
  postcard: "Postcard",
  sepia_print: "Sepia print",
  slide: "Slide",
  textile: "Textile"
}

export const isClient = typeof window !== "undefined"

export const VALID_SORTS = [
  // Note the id key in these maps to a translation in messages/lists.js
  { v: "updated", l: "Uploaded Date (Newest)", id: "sortUpdatedNewest" },
  { v: "updated:last", l: "Uploaded Date (Oldest)", id: "sortUpdatedOldest" },
  { v: "relevance", l: "Relevance", id: "sortRelevance" },
  { v: "date", l: "Created Date (Newest)", id: "sortDateNewest" },
  { v: "date:last", l: "Created Date (Oldest)", id: "sortDateOldest" }
]

export const MOBILE_ARTICLE_STYLE_ID = "fluid"

export const SEARCH_ARTICLE_STYLES = [
  // Note the id key in these maps to a translation in messages/search.js
  { id: "fluid", message: "fluidGridView" },
  { id: "grid", message: "structuredGridView" },
  { id: "details", message: "detailsView" }
  //{ id: "map", message: "mapView" },
  //{ id: "list", message: "listView" }
]

export const SET_ARTICLE_STYLES = [
  // Note the id key in these maps to a translation in messages/search.js
  { id: "fluid", message: "fluidGridView" },
  { id: "grid", message: "structuredGridView" },
  { id: "details", message: "detailsView" }
  //{ id: "list", message: "listView" }
]

export const VALID_HELD_INS = invert(HELD_IN_NAMES)

export const LANGUAGE = {
  en: "English",
  es: "Spanish",
  fr: "French",
  hi: "Hindi",
  mi: "Maori",
  sm: "Samoan",
  to: "Tongan",
  zh: "Chinese"
}

export const LANGUAGE_INVERTED = invert(LANGUAGE)

// Note these must be manually included in the
// Relay Query of Search.js ( everthing else should be automatic )
export const FILTER_CONTROLS = [
  { name: "creator", type: "suggest", id: "fieldNameCreator", isDefault: true },
  { name: "title", type: "suggest", id: "fieldNameTitle", isDefault: true },
  {
    name: "language",
    type: "facet",
    join: "OR",
    prepareValue: value => LANGUAGE_INVERTED[value] || value,
    prepareDisplay: value => LANGUAGE[value] || value,
    id: "fieldNameLanguage",
    isDefault: true
  },
  {
    name: "held_in",
    type: "facet",
    join: "OR",
    prepareValue: value => VALID_HELD_INS[value] || value,
    prepareDisplay: value => HELD_IN_NAMES[value] || value,
    id: "fieldNameHeldIn"
  },
  {
    name: "original_held_in",
    type: "suggest",
    join: "OR",
    prepareValue: value => VALID_HELD_INS[value] || value,
    prepareDisplay: value => HELD_IN_NAMES[value] || value,
    id: "fieldNameOriginalHeldIn"
  }
]

export const DEFAULT_FILTER_JOIN = "AND"

// Pages that should not be displayed for some projects
export const INACTIVE_ROUTES = ["/", "/contribute", "/user/contributions"]

export const CON_TOP_MUSEUM_HOSTNAME = "collection.conetopmuseum.com"



// WEBPACK FOOTER //
// ./webapp/constants.js